export const EmptyPpsrSummary: RegistrationSummary = {
	expireNextThreeMonths: 0,
	expireNextSixMonths: 0,
	expireNextYear: 0,
	current: 0,
} 

export interface RegistrationSummary {
	expireNextThreeMonths: number,
	expireNextSixMonths: number,
	expireNextYear: number,
	current: number,
}

export interface LinkData {
	url?: string,
	label: string,
	active: boolean,
}

export interface Grantor {
	customerType: string,
	organisationName: string,
	organisationNumber: string,
	organisationNumberType: string,
	registrationId: number,
	givenNames: string,
	familyName: string,
	dateOfBirth: string,
}

export interface PpsrRegistrationData {
	id: string,
	businessEntityId: string,
	securedPartyGroup: {
		id: number,
		name: string,
		spgNumber: string,
	},
	contractId: string,
	collateralClass: string,
	collateralDescription: string,
	status: string,
	goni: string,
	serialNumber: string,
	serialNumberType: string,
	vehicleDescriptiveText: string,
	vehicleRegistrationNumber: string,
	ppsrRegistrationNumber: string,
	ppsrRegistrationChangeNumber: string,
	ppsrRegistrationStartTime: string,
	ppsrRegistrationEndTime: string,
	ppsrDischargeData: string,
	freeText1: string,
	grantors: Grantor,
	match: string,
}

export interface RegistrationInformation {
	currentPage: number,
	data: PpsrRegistrationData[],
	firstPageUrl: string,
	from?: number,
	lastPage: number,
	lastPageUrl?: string,
	links: LinkData[],
	nextPageUrl?: string,
	path: string,
	perPage: string,
	prevPageUrl?: string,
	to?: number,
	total: number,
}

export interface FetchRegistrationResponse {
	summary: RegistrationSummary,
	registrations: RegistrationInformation,
	message?: string,
}

export interface PpsrIndividualRegistrationData {
	id: number,
	businessEntityId: number,
	securedPartyGroup: {
		id: number,
		name: string,
		spgNumber: string,
	},
	contractId: string | null,
	collateralClass: string | null,
	collateralDescription: string | null,
	status: string | null,
	goni: string | null,
	serialNumber: string | null,
	serialNumberType: string | null,
	vehicleDescriptiveText: string | null,
	vehicleRegistrationNumber: string | null,
	ppsrRegistrationNumber: string | null,
	ppsrRegistrationChangeNumber: string | null,
	ppsrRegistrationStartTime: string | null,
	ppsrRegistrationEndTime: string | null,
	ppsrDischargeDate: string | null,
	freeText1: string | null,
	createdBy: ChangeOwner | null,
	createdDate: string | null,
	updatedBy: ChangeOwner | null,
	updatedDate: string | null,
	grantors: IndividualRegistrationGrantor[] | null,
}

export interface IndividualRegistrationGrantor {
	grantorType: string,
	familyName: string | null,
	givenNames: string | null,
	dateOfBirth: string | null,
	organisationName: string | null,
	organisationNumber: string | null,
	organisationNumberType: string | null,
	registrationId: number,
}

export interface ChangeOwner {
	id: number,
	name: string,
	email: string,
	username: string,
}

export interface FetchIndividualRegistrationResponse {
	registration: PpsrIndividualRegistrationData | null,
	message: string | null,
}
